import Error501page from "./ErrorPage";
export default Error501page;